const en = {
  nav: {
    home: 'Home',
    about: 'About',
    solutions: 'Solutions',
    industries: 'Industries',
    contact: 'Contact',
  },

  home: {
    phases: [
      {
        h1Before: 'Tailored ',
        h1Highlight: 'IT',
        h1After: ' solutions',
        h3: 'that scale with your business',
        cols: [
          { border: 'l-blue', lines: ['Digital', 'Presence'] },
          { border: 'l-cyan', lines: ['Application', 'Engineering'] },
          { border: 'l-pink', lines: ['Enterprise', 'Integration'] },
        ],
      },
      {
        h1Before: 'Our ',
        h1Highlight: 'Value',
        h1After: ' Proposition',
        h3: 'that scale with your business',
        cols: [
          { border: 'l-blue', lines: ['Process', 'Optimization'] },
          { border: 'l-cyan', lines: ['Digital', 'Transformation'] },
          { border: 'l-pink', lines: ['Data-Driven', 'Decisions'] },
        ],
      },
      {
        h1Before: 'Strategic ',
        h1Highlight: 'Business',
        h1After: ' Alignment',
        h3: 'that scale with your business',
        cols: [
          { border: 'l-blue', lines: ['Strategic', 'Clarity'] },
          { border: 'l-cyan', lines: ['Expert', 'Execution'] },
          { border: 'l-pink', lines: ['Long-Term', 'Partnership'] },
        ],
      },
    ],
  },

  about: {
    slides: [
      {
        tag: 'About',
        accent: 'var(--violet)',
        titleBefore: 'About ',
        titleHighlight: 'Us',
        subtitle: 'Founded in 2018 and headquartered in Goslar, Germany — with development teams in Germany and India.',
        body: 'Built for SMEs and social initiatives, we harness technology as a catalyst for sustainable growth — bridging the gap between great ideas and the digital solutions that bring them to life.',
        features: [
          { label: 'Founded in Goslar, Germany — 2018' },
          { label: 'Teams across Germany & India' },
          { label: 'Built for SMEs & Social Initiatives' },
        ],
        quoteBefore: 'We bridge the digital execution gap through Proxy Product Ownership, translating complex business requirements into reliable, scalable, high-performance digital solutions.',
        quoteAuthor: 'Strategic Alignment',
      },
      {
        tag: 'About',
        accent: 'var(--cyan)',
        titleBefore: 'Our ',
        titleHighlight: 'Vision',
        subtitle: 'Empowering SMEs Through Digital Transformation and Innovation.',
        body: 'At 7elemente, we envision a future where small and mid-sized enterprises reach their highest potential by aligning digital capabilities with strategic clarity. Our goal is to empower SMEs to operate at optimal capacity, achieving their business objectives efficiently through impactful Digital Transformation.',
        features: [
          { label: 'Inspire' },
          { label: 'Innovate' },
          { label: 'Impact' },
        ],
        quoteBefore: 'The next generation of market leaders will not be defined by size — they will be defined by how well they use technology.',
        quoteAuthor: 'Our Vision',
      },
      {
        tag: 'About',
        accent: 'var(--highlight)',
        titleBefore: 'Our ',
        titleHighlight: 'Mission',
        subtitle: 'Co-Creating Scalable Solutions.',
        body: 'We co-create digital solutions that grow with our clients — scaling with their capacity, aligned with their ambitions, and rooted in long-term value. Through thoughtful design, intelligent systems, and strategic partnership, we ensure your Digital Transformation journey delivers lasting impact.',
        features: [
          { label: 'Strategic Clarity' },
          { label: 'Expert Execution' },
          { label: 'Trusted Partner' },
        ],
        quoteBefore: "You focus on your business goals — we'll be your IT wing.",
        quoteAuthor: 'Our Mission',
      },
    ],
  },

  solutions: {
    slides: [
      {
        tag: 'Solution',
        accent: 'var(--violet)',
        video: 'digexp',
        titleBefore: 'Digital ',
        titleHighlight: 'Presence',
        subtitle: "Your online presence isn't just a website — it's your digital handshake.",
        body: 'We craft seamless digital experiences that blend design, technology, and performance. From visually striking websites to performance-optimized platforms, we help you gain visibility, drive engagement, and grow with purpose. Let your digital experience speak louder than words.',
        features: [
          { label: 'Responsive Web Design' },
          { label: 'SEO & Performance' },
          { label: 'Digital Transformation' },
        ],
        quoteBefore: 'Your website is your best salesperson — working around the clock, reaching anyone, anywhere.',
        quoteAuthor: 'Digital First',
      },
      {
        tag: 'Solution',
        accent: 'var(--cyan)',
        video: 'appeng',
        titleBefore: 'Application ',
        titleHighlight: 'Engineering',
        subtitle: 'Interfaces to enterprise grade backend systems — we engineer it all.',
        body: 'From startups to scaling products and modernizing legacy systems, we turn ideas into powerful digital products — combining thoughtful design with scalable, seamless technology.',
        features: [
          { label: 'Custom Web Applications' },
          { label: 'Mobile App Development' },
          { label: 'Workflow Automation' },
        ],
        quoteBefore: 'Good software is not about writing code — it is about solving the right problems in the simplest possible way.',
        quoteAuthor: 'Engineering Mindset',
      },
      {
        tag: 'Solution',
        accent: 'var(--highlight)',
        video: 'entint',
        titleBefore: 'Enterprise ',
        titleHighlight: 'Intelligence',
        subtitle: 'From strategy to cloud, from data to process — we help enterprises evolve.',
        body: 'At 7element, we help retail and manufacturing businesses streamline operations, unify digital and physical experiences, and scale with confidence. From connected eCommerce to ERP and PIM integration, we reduce friction and drive operational excellence.',
        features: [
          { label: 'PIM Solutions' },
          { label: 'Cloud Infrastructure' },
          { label: 'System Integration' },
        ],
        quoteBefore: 'Integration is not a technical challenge — it is a strategic one. Connected systems create connected organisations.',
        quoteAuthor: 'Enterprise Strategy',
      },
    ],
  },

  industries: {
    slides: [
      {
        tag: 'Industry',
        accent: 'var(--violet)',
        video: 'manufacturing',
        title: 'Retail & Manufacturing',
        subtitle: 'Digitizing Retail journeys and modernizing Manufacturing pipelines.',
        body: 'At 7element, we help retail and manufacturing businesses streamline operations, unify digital and physical experiences, and scale with confidence. From connected eCommerce to ERP and PIM integration, we reduce friction and drive operational excellence.',
        features: [
          { label: 'Product Information Management (PIM)' },
          { label: 'E-Commerce & Online Presence' },
          { label: 'Operations & Supply Chain Integration' },
        ],
        quoteBefore: 'Disconnected systems create disconnected experiences. We bring it all together — intelligently, seamlessly, and at scale.',
        quoteAuthor: 'Retail & Manufacturing',
      },
      {
        tag: 'Industry',
        accent: 'var(--cyan)',
        video: 'education',
        title: 'Education & Training',
        subtitle: 'Empowering learning through digital innovation.',
        body: "In today's evolving education landscape, digital transformation enhances learning, streamlines administration, and expands access. We help institutions deliver personalized, scalable, and engaging learning experiences.",
        features: [
          { label: 'E-Learning Platform Development' },
          { label: 'Content & Course Management' },
          { label: 'EdTech Application Engineering' },
        ],
        quoteBefore: "Education is evolving, and so should its tools. Embracing digital transformation is not just an option — it's a necessity for future-ready learning.",
        quoteAuthor: 'Education & Training',
      },
      {
        tag: 'Industry',
        accent: 'var(--highlight)',
        video: 'dna',
        title: 'Healthcare & Wellness',
        subtitle: 'Secure, connected, and human-centered digital health solutions.',
        body: 'Digital transformation is reshaping healthcare by improving patient care, streamlining operations, and ensuring compliance. We build secure, scalable systems that enable personalized and adaptive care experiences.',
        features: [
          { label: 'Patient-Facing Web Applications' },
          { label: 'GDPR-Compliant Data Management' },
          { label: 'Booking & Workflow Automation' },
        ],
        quoteBefore: "In healthcare, every data point represents a life. Ensuring seamless, secure, and accessible information flow is not just a technical necessity — it's a moral imperative.",
        quoteAuthor: 'Healthcare & Wellness',
      },
    ],
  },

  contact: {
    navContact: 'Contact',
    navImpression: 'Impression',
    tag: 'Get In Touch',
    heading: 'Contact',
    headingHighlight: '',
    intro: "Whether you're starting from scratch or scaling up, we'd love to hear about your goals. Reach out and one of our experts will get back to you within 24 hours.",
    addressLabel: 'Address',
    emailLabel: 'Email',
    phoneLabel: 'Phone',
    form: {
      namePlaceholder: 'Your name',
      emailPlaceholder: 'your@email.com',
      companyPlaceholder: 'Your company name',
      messagePlaceholder: 'Tell us about your project...',
      nameLabel: 'Name',
      emailLabel: 'Email',
      companyLabel: 'Company',
      messageLabel: 'Message',
      submit: 'Send Message',
      sending: 'Sending…',
    },
    successHeading: 'Message sent!',
    successBody: "We'll be in touch within 24 hours.",
    errorMsg: 'Something went wrong. Please try again or email us directly.',
    impression: {
      tag: 'Legal',
      titleBefore: 'Legal ',
      titleHighlight: 'Notice',
      subtitle: '7Elemente IT-Solutions UG (haftungsbeschränkt)',
      body: 'In accordance with § 5 TMG (Telemediengesetz). This website is operated by 7Elemente IT-Solutions UG. All content is subject to German copyright law.',
      features: [
        { label: 'Bahnhofstraße 11, 38642 Goslar, Germany' },
        { label: 'Email: info@7Elemente.com' },
        { label: 'Phone: +49 5321 39 49 49 6' },
        { label: 'Register: Amtsgericht Braunschweig' },
      ],
      quoteBefore: 'Transparency is not just a legal obligation — it is a reflection of how we do business.',
      quoteAuthor: 'Legal Notice',
    },
  },
  mitra: {
    slides: [
      {
        letter: 'M',
        tag: 'Our Values',
        titleBefore: '',
        titleHighlight: 'Mastery',
        subtitle: '15+ years of enterprise IT excellence.',
        body: 'We bring deep expertise across SAP, Microsoft Dynamics, cloud infrastructure, and modern web development — earned through real-world enterprise delivery, not theory.',
        features: [
          { label: 'Enterprise Architecture' },
          { label: 'Cross-Domain Expertise' },
          { label: 'Proven Delivery' },
        ],
        accent: 'var(--violet)',
        quote: 'Excellence is not a skill — it is a habit built over years of solving the problems others could not.',
      },
      {
        letter: 'I',
        tag: 'Our Values',
        titleBefore: '',
        titleHighlight: 'Integrity',
        subtitle: 'Transparent delivery, every step of the way.',
        body: 'We believe in honest communication, realistic timelines, and no hidden costs. Our clients always know where their project stands — and why.',
        features: [
          { label: 'Transparent Pricing' },
          { label: 'Honest Timelines' },
          { label: 'Clear Communication' },
        ],
        accent: 'var(--cyan)',
        quote: 'The foundation of every great partnership is trust — and trust is built through transparency.',
      },
      {
        letter: 'T',
        tag: 'Our Values',
        titleBefore: '',
        titleHighlight: 'Talent',
        subtitle: 'A curated network of expert professionals.',
        body: 'We handpick specialists from our network of senior engineers, designers, and strategists — assembling the right team for every unique challenge.',
        features: [
          { label: 'Senior-Only Network' },
          { label: 'Domain Specialists' },
          { label: 'Agile Teams' },
        ],
        accent: 'var(--highlight)',
        quote: 'Great products are not built by great companies — they are built by great people.',
      },
      {
        letter: 'R',
        tag: 'Our Values',
        titleBefore: '',
        titleHighlight: 'Reliability',
        subtitle: 'On time, on budget — every time.',
        body: 'We set realistic expectations and deliver on them. Our structured approach to project management ensures consistent quality from kickoff to launch.',
        features: [
          { label: 'Milestone-Driven Delivery' },
          { label: 'Quality Assurance' },
          { label: 'Post-Launch Support' },
        ],
        accent: 'var(--violet)',
        quote: 'Reliability is not about being perfect — it is about being dependable when it matters most.',
      },
      {
        letter: 'A',
        tag: 'Our Values',
        titleBefore: '',
        titleHighlight: 'Adaptability',
        subtitle: 'Agile, future-proof, and always evolving.',
        body: 'Technology changes fast. We stay ahead of the curve — adopting new tools, frameworks, and methodologies to ensure your solutions remain competitive for years to come.',
        features: [
          { label: 'Agile Methodology' },
          { label: 'Future-Proof Architecture' },
          { label: 'Continuous Innovation' },
        ],
        accent: 'var(--cyan)',
        quote: 'The companies that thrive are not the strongest — they are the ones most responsive to change.',
      },
    ],
  },
};

export default en;
